import { TimeZoneDetailsModel } from '../models/time-zone-details.model';

// Moment timezone ids from https://github.com/moment/moment-timezone/blob/develop/data/packed/latest.json
export const timeZones: TimeZoneDetailsModel[] = [
    {
        gmtOffset: -12,
        name: 'Timezones.DTS',
        momentId: 'Etc/GMT+12',
        agilityIds: ['Etc/GMT+12']
    },
    {
        gmtOffset: -11,
        name: 'Timezones.pacificPagoPago',
        momentId: 'Pacific/Pago_Pago',
        agilityIds: ['Etc/GMT+11']
    },
    {
        gmtOffset: -10,
        name: 'Timezones.hawaii',
        momentId: 'Pacific/Honolulu',
        agilityIds: ['Pacific/Honolulu']
    },
    {
        gmtOffset: -9,
        name: 'Timezones.alaska',
        momentId: 'America/Anchorage',
        agilityIds: ['America/Anchorage']
    },
    {
        gmtOffset: -8,
        name: 'Timezones.losangeles',
        momentId: 'America/Los_Angeles',
        agilityIds: ['America/Los_Angeles']
    },
    {
        gmtOffset: -8,
        name: 'Timezones.tijuana',
        momentId: 'America/Tijuana',
        agilityIds: ['America/Tijuana']
    },
    {
        gmtOffset: -7,
        name: 'Timezones.denver',
        momentId: 'America/Denver',
        agilityIds: ['America/Denver']
    },
    {
        gmtOffset: -7,
        name: 'Timezones.vancouver',
        momentId: 'America/Vancouver',
        agilityIds: ['America/Vancouver']
    },
    {
        gmtOffset: -7,
        name: 'Timezones.laPaz',
        momentId: 'America/Mazatlan',
        agilityIds: ['America/Mazatlan']
    },
    {
        gmtOffset: -7,
        name: 'Timezones.arizona',
        momentId: 'America/Phoenix',
        agilityIds: ['America/Phoenix']
    },
    {
        gmtOffset: -6,
        name: 'Timezones.kansasCity',
        momentId: 'America/Chicago',
        agilityIds: ['America/Chicago']
    },
    {
        gmtOffset: -6,
        name: 'Timezones.edmonton',
        momentId: 'America/Edmonton',
        agilityIds: ['America/Edmonton', 'America/Yellowknife']
    },
    {
        gmtOffset: -6,
        name: 'Timezones.mexicoCity.central',
        momentId: 'America/Mexico_City',
        agilityIds: ['America/Mexico_City']
    },
    {
        gmtOffset: -6,
        name: 'Timezones.saskatoon',
        momentId: 'America/Regina',
        agilityIds: ['America/Regina']
    },
    {
        gmtOffset: -6,
        name: 'Timezones.mexicoCity.mexico',
        momentId: 'America/Mexico_City',
        agilityIds: ['']
    },
    {
        gmtOffset: -6,
        name: 'Timezones.centralAmerica',
        momentId: 'America/Guatemala',
        agilityIds: ['America/Guatemala']
    },
    {
        gmtOffset: -5,
        name: 'Timezones.newYork',
        momentId: 'America/New_York',
        agilityIds: ['America/Toronto']
    },
    {
        gmtOffset: -5,
        name: 'Timezones.indianapolis',
        momentId: 'America/Indiana/Indianapolis',
        agilityIds: ['America/Indiana/Indianapolis']
    },
    {
        gmtOffset: -5,
        name: 'Timezones.bogota',
        momentId: 'America/Bogota',
        agilityIds: ['America/Bogota']
    },
    {
        gmtOffset: -5,
        name: 'Timezones.winnipeg',
        momentId: 'America/Winnipeg',
        agilityIds: ['America/Winnipeg']
    },
    {
        gmtOffset: -4,
        name: 'Timezones.caracas',
        momentId: 'America/Caracas',
        agilityIds: ['America/Caracas']
    },
    {
        gmtOffset: -4,
        name: 'Timezones.halifax',
        momentId: 'America/Halifax',
        agilityIds: ['America/Halifax']
    },
    {
        gmtOffset: -4,
        name: 'Timezones.sanJuan',
        momentId: 'America/Puerto_Rico',
        agilityIds: ['America/La_Paz']
    },
    {
        gmtOffset: -4,
        name: 'Timezones.santiago',
        momentId: 'America/Santiago',
        agilityIds: ['America/Santiago']
    },
    {
        gmtOffset: -4,
        name: 'Timezones.manaus',
        momentId: 'America/Cuiaba',
        agilityIds: ['America/Cuiaba']
    },
    {
        gmtOffset: -4,
        name: 'Timezones.asuncion',
        momentId: 'America/Asuncion',
        agilityIds: ['America/Asuncion']
    },
    {
        gmtOffset: -3.5,
        name: 'Timezones.newfoundland',
        momentId: 'America/St_Johns',
        agilityIds: ['America/St_Johns']
    },
    {
        gmtOffset: -3,
        name: 'Timezones.saoPaulo',
        momentId: 'America/Bahia',
        agilityIds: ['America/Bahia', 'Etc/GMT+3']
    },
    {
        gmtOffset: -3,
        name: 'Timezones.cayenne',
        momentId: 'America/Cayenne',
        agilityIds: ['America/Cayenne']
    },
    {
        gmtOffset: -3,
        name: 'Timezones.buenosAires',
        momentId: 'America/Argentina/Buenos_Aires',
        agilityIds: ['America/Argentina/Buenos_Aires']
    },
    {
        gmtOffset: -3,
        name: 'Timezones.montevideo',
        momentId: 'America/Montevideo',
        agilityIds: ['America/Montevideo']
    },
    {
        gmtOffset: -3,
        name: 'Timezones.greenland',
        momentId: 'America/Godthab',
        agilityIds: ['America/Godthab']
    },
    {
        gmtOffset: -2,
        name: 'Timezones.midAtlantic',
        momentId: 'Atlantic/South_Georgia',
        agilityIds: ['Atlantic/South_Georgia']
    },
    {
        gmtOffset: -2,
        name: 'Timezones.atlanticSouthGeorgia',
        momentId: 'Atlantic/South_Georgia',
        agilityIds: ['Etc/GMT+2']
    },
    {
        gmtOffset: -1,
        name: 'Timezones.azores',
        momentId: 'Atlantic/Azores',
        agilityIds: ['Atlantic/Azores']
    },
    {
        gmtOffset: -1,
        name: 'Timezones.capeVerde',
        momentId: 'Atlantic/Cape_Verde',
        agilityIds: ['Atlantic/Cape_Verde']
    },
    {
        gmtOffset: 0,
        name: 'Timezones.UTC',
        momentId: 'UTC',
        agilityIds: ['Etc/UTC', 'UTC']
    },
    {
        gmtOffset: 0,
        name: 'Timezones.london',
        momentId: 'Europe/London',
        agilityIds: ['Europe/London']
    },
    {
        gmtOffset: 0,
        name: 'Timezones.monrovia',
        momentId: 'Africa/Monrovia',
        agilityIds: ['Africa/Monrovia']
    },
    {
        gmtOffset: 0,
        name: 'Timezones.casablanca',
        momentId: 'Africa/Casablanca',
        agilityIds: ['Africa/Casablanca']
    },
    {
        gmtOffset: 1,
        name: 'Timezones.budapest',
        momentId: 'Europe/Belgrade',
        agilityIds: ['Europe/Belgrade']
    },
    {
        gmtOffset: 1,
        name: 'Timezones.warsaw',
        momentId: 'Europe/Belgrade',
        agilityIds: ['Europe/Belgrade']
    },
    {
        gmtOffset: 1,
        name: 'Timezones.paris',
        momentId: 'Europe/Brussels',
        agilityIds: ['Europe/Brussels']
    },
    {
        gmtOffset: 1,
        name: 'Timezones.berlin',
        momentId: 'Europe/Amsterdam',
        agilityIds: ['Europe/Amsterdam']
    },
    {
        gmtOffset: 1,
        name: 'Timezones.lagos',
        momentId: 'Africa/Lagos',
        agilityIds: ['Etc/GMT-1']
    },
    {
        gmtOffset: 2,
        name: 'Timezones.minsk',
        momentId: 'Europe/Minsk',
        agilityIds: ['Europe/Istanbul', 'Europe/Nicosia', 'Europe/Kaliningrad']
    },
    {
        gmtOffset: 2,
        name: 'Timezones.cairo',
        momentId: 'Africa/Cairo',
        agilityIds: ['Africa/Cairo']
    },
    {
        gmtOffset: 2,
        name: 'Timezones.kiev',
        momentId: 'Europe/Helsinki',
        agilityIds: ['Europe/Helsinki']
    },
    {
        gmtOffset: 2,
        name: 'Timezones.bucharest',
        momentId: 'Europe/Athens',
        agilityIds: ['Europe/Athens']
    },
    {
        gmtOffset: 2,
        name: 'Timezones.jerusalem',
        momentId: 'Asia/Jerusalem',
        agilityIds: ['Asia/Jerusalem']
    },
    {
        gmtOffset: 2,
        name: 'Timezones.pretoria',
        momentId: 'Africa/Johannesburg',
        agilityIds: ['Africa/Maputo']
    },
    {
        gmtOffset: 2,
        name: 'Timezones.beirut',
        momentId: 'Asia/Beirut',
        agilityIds: ['Asia/Beirut']
    },
    {
        gmtOffset: 2,
        name: 'Timezones.amman',
        momentId: 'Asia/Amman',
        agilityIds: ['Asia/Amman', 'Asia/Damascus']
    },
    {
        gmtOffset: 2,
        name: 'Timezones.windhoek',
        momentId: 'Africa/Windhoek',
        agilityIds: ['Africa/Windhoek']
    },
    {
        gmtOffset: 3,
        name: 'Timezones.stPetersburg',
        momentId: 'Europe/Moscow',
        agilityIds: ['Europe/Moscow']
    },
    {
        gmtOffset: 3,
        name: 'Timezones.riyadh',
        momentId: 'Asia/Riyadh',
        agilityIds: ['Asia/Riyadh']
    },
    {
        gmtOffset: 3,
        name: 'Timezones.nairobi',
        momentId: 'Africa/Nairobi',
        agilityIds: ['Africa/Nairobi']
    },
    {
        gmtOffset: 3,
        name: 'Timezones.baghdad',
        momentId: 'Asia/Baghdad',
        agilityIds: ['Asia/Baghdad']
    },
    {
        gmtOffset: 3,
        name: 'Timezones.tbilisi',
        momentId: 'Asia/Tbilisi',
        agilityIds: ['Asia/Tbilisi']
    },
    {
        gmtOffset: 3.5,
        name: 'Timezones.tehran',
        momentId: 'Asia/Tehran',
        agilityIds: ['Asia/Tehran']
    },
    {
        gmtOffset: 4,
        name: 'Timezones.dubai',
        momentId: 'Asia/Dubai',
        agilityIds: ['Asia/Dubai']
    },
    {
        gmtOffset: 4,
        name: 'Timezones.yerevan.caucasus',
        momentId: 'Asia/Baku',
        agilityIds: ['Asia/Baku']
    },
    {
        gmtOffset: 4,
        name: 'Timezones.yerevan.armenian',
        momentId: 'Asia/Yerevan',
        agilityIds: ['Asia/Yerevan']
    },
    {
        gmtOffset: 4,
        name: 'Timezones.portLouis',
        momentId: 'Indian/Mauritius',
        agilityIds: ['Indian/Mauritius']
    },
    {
        gmtOffset: 4.5,
        name: 'Timezones.kabul',
        momentId: 'Asia/Kabul',
        agilityIds: ['Asia/Kabul']
    },
    {
        gmtOffset: 5,
        name: 'Timezones.ekaterinburg',
        momentId: 'Asia/Yekaterinburg',
        agilityIds: ['']
    },
    {
        gmtOffset: 5,
        name: 'Timezones.tashkent',
        momentId: 'Asia/Tashkent',
        agilityIds: ['Asia/Tashkent']
    },
    {
        gmtOffset: 5,
        name: 'Timezones.islamabad',
        momentId: 'Asia/Karachi',
        agilityIds: ['Asia/Karachi']
    },
    {
        gmtOffset: 5.5,
        name: 'Timezones.kolkata',
        momentId: 'Asia/Kolkata',
        agilityIds: ['Asia/Kolkata', 'Asia/Colombo']
    },
    {
        gmtOffset: 5.75,
        name: 'Timezones.kathmandu',
        momentId: 'Asia/Kathmandu',
        agilityIds: ['Asia/Kathmandu']
    },
    {
        gmtOffset: 6,
        name: 'Timezones.dhaka',
        momentId: 'Asia/Dhaka',
        agilityIds: ['Etc/GMT-6', 'Asia/Dhaka', 'Asia/Yekaterinburg']
    },
    {
        gmtOffset: 6,
        name: 'Timezones.colombo',
        momentId: 'Asia/Colombo',
        agilityIds: ['']
    },
    {
        gmtOffset: 6,
        name: 'Timezones.novosibirsk',
        momentId: 'Asia/Novosibirsk',
        agilityIds: ['Asia/Novosibirsk']
    },
    {
        gmtOffset: 6.5,
        name: 'Timezones.yangon',
        momentId: 'Asia/Yangon',
        agilityIds: ['Asia/Yangon']
    },
    {
        gmtOffset: 7,
        name: 'Timezones.bangkok',
        momentId: 'Asia/Bangkok',
        agilityIds: ['Asia/Bangkok']
    },
    {
        gmtOffset: 7,
        name: 'Timezones.krasnoyarsk',
        momentId: 'Asia/Krasnoyarsk',
        agilityIds: ['Asia/Krasnoyarsk']
    },
    {
        gmtOffset: 8,
        name: 'Timezones.shanghai',
        momentId: 'Asia/Shanghai',
        agilityIds: ['Asia/Hong_Kong']
    },
    {
        gmtOffset: 8,
        name: 'Timezones.singapore',
        momentId: 'Asia/Singapore',
        agilityIds: ['Asia/Singapore']
    },
    {
        gmtOffset: 8,
        name: 'Timezones.taipei',
        momentId: 'Asia/Taipei',
        agilityIds: ['Asia/Taipei']
    },
    {
        gmtOffset: 8,
        name: 'Timezones.perth',
        momentId: 'Australia/Perth',
        agilityIds: ['Australia/Perth']
    },
    {
        gmtOffset: 8,
        name: 'Timezones.irkutsk',
        momentId: 'Asia/Irkutsk',
        agilityIds: ['Asia/Irkutsk', 'Asia/Ulaanbaatar']
    },
    {
        gmtOffset: 9,
        name: 'Timezones.seoul',
        momentId: 'Asia/Seoul',
        agilityIds: ['Asia/Seoul']
    },
    {
        gmtOffset: 9,
        name: 'Timezones.tokyo',
        momentId: 'Asia/Tokyo',
        agilityIds: ['Asia/Tokyo']
    },
    {
        gmtOffset: 9,
        name: 'Timezones.yakutsk',
        momentId: 'Asia/Yakutsk',
        agilityIds: ['Asia/Yakutsk']
    },
    {
        gmtOffset: 9.5,
        name: 'Timezones.darwin',
        momentId: 'Australia/Darwin',
        agilityIds: ['Australia/Darwin']
    },
    {
        gmtOffset: 9.5,
        name: 'Timezones.adelaide',
        momentId: 'Australia/Adelaide',
        agilityIds: ['Australia/Adelaide']
    },
    {
        gmtOffset: 10,
        name: 'Timezones.sydney',
        momentId: 'Australia/Sydney',
        agilityIds: ['Australia/Sydney']
    },
    {
        gmtOffset: 10,
        name: 'Timezones.brisbane',
        momentId: 'Australia/Brisbane',
        agilityIds: ['Australia/Brisbane']
    },
    {
        gmtOffset: 10,
        name: 'Timezones.hobart',
        momentId: 'Australia/Hobart',
        agilityIds: ['Australia/Hobart']
    },
    {
        gmtOffset: 10,
        name: 'Timezones.vladivostok',
        momentId: 'Asia/Vladivostok',
        agilityIds: ['Asia/Vladivostok']
    },
    {
        gmtOffset: 10,
        name: 'Timezones.guam',
        momentId: 'Pacific/Guam',
        agilityIds: ['Pacific/Guam']
    },
    {
        gmtOffset: 11,
        name: 'Timezones.solomonIslands',
        momentId: 'Pacific/Guadalcanal',
        agilityIds: ['Etc/GMT-11', 'Asia/Magadan']
    },
    {
        gmtOffset: 12,
        name: 'Timezones.pacificWake',
        momentId: 'Pacific/Wake',
        agilityIds: ['Etc/GMT-12']
    },
    {
        gmtOffset: 12,
        name: 'Timezones.fiji',
        momentId: 'Pacific/Fiji',
        agilityIds: ['Pacific/Fiji']
    },
    {
        gmtOffset: 12,
        name: 'Timezones.auckland',
        momentId: 'Pacific/Auckland',
        agilityIds: ['Pacific/Auckland']
    },
    {
        gmtOffset: 12,
        name: 'Timezones.kamchatsky',
        momentId: 'Asia/Kamchatka',
        agilityIds: ['Asia/Kamchatka']
    },
    {
        gmtOffset: 13,
        name: 'Timezones.samoa',
        momentId: 'Pacific/Apia',
        agilityIds: ['Pacific/Samoa']
    },
    {
        gmtOffset: 13,
        name: 'Timezones.nukualofa',
        momentId: 'Pacific/Tongatapu',
        agilityIds: ['Etc/GMT-13']
    }
];

export const momentTimeZoneMap: Map<string, TimeZoneDetailsModel> = new Map<string, TimeZoneDetailsModel>();
export const agilityTimeZoneMap: Map<string, TimeZoneDetailsModel> = new Map<string, TimeZoneDetailsModel>();

timeZones.forEach((zone) => {
    if (!momentTimeZoneMap.has(zone.momentId)) {
        momentTimeZoneMap.set(zone.momentId, zone);
    }
    zone.agilityIds.forEach((id) => {
        if (!agilityTimeZoneMap.has(id)) {
            agilityTimeZoneMap.set(id, zone);
        }
    });
});

